var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheeseSwiss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368 336.005C341.5 336.005 320 314.506 320 288.007H0V448.001C0 465.626 14.375 480 32 480H480C497.625 480 512 465.626 512 448.001V288.007H416C416 314.506 394.5 336.005 368 336.005ZM176 432.002C149.5 432.002 128 410.503 128 384.004S149.5 336.005 176 336.005S224 357.505 224 384.004S202.5 432.002 176 432.002ZM299.875 32.017C292.125 31.767 284.625 34.267 278.75 39.017L217 87.015C229.625 107.889 224.625 134.763 205.5 149.763C186.25 164.762 158.875 162.887 141.875 145.513L0 256.009H512C512 136.138 417.999 38.267 299.875 32.017Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheeseSwiss);
export default __webpack_public_path__ + "static/media/cheese-swiss.97b67cb885b26e01067538371edfd7df.svg";
export { ForwardRef as ReactComponent };